import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import config from "../../config/config";

export function ViewSupplier() {
  const [suppliers, setSuppliers] = useState([]);
  const navigate = useNavigate();


  // Fetch Data
  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/SupplierDetails/supDetails`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setSuppliers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch Supplier Details", error);
      setSuppliers([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);




  const handleEdit = (id) => {
    console.log("Edit ID:", id);
    // You would typically navigate to an edit page here:
    navigate(`/supplier/edit/${id}`);
  };

  return (
    <div className="p-2">
      <h1 className="text-2xl font-bold mb-6 text-indigo-800">View Suppliers</h1>
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-indigo-800 ">
              <tr className='font-bold text-white text-center'>
                <th className="px-6 py-3 text-xs uppercase">ID</th>
                <th className="px-6 py-3 text-xs uppercase">Name</th>
                <th className="px-6 py-3 text-xs uppercase">Type</th>
                <th className="px-6 py-3 text-xs uppercase">Category</th>
                <th className="px-6 py-3 text-xs uppercase">Agreed Amt</th>
                <th className="px-6 py-3 text-xs uppercase">Animals</th>
                <th className="px-6 py-3 text-xs uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 text-center">
              {suppliers.length > 0 ? (
                suppliers.map((supplier, index) => (
                  <tr key={supplier.id || index} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm">{supplier.id}</td>
                    <td className="px-6 py-4 text-sm font-medium">{supplier.supname}</td>
                    <td className="px-6 py-4 text-sm">{supplier.type}</td>
                    <td className="px-6 py-4 text-sm">{supplier.category}</td>
                    <td className="px-6 py-4 text-sm text-right">{supplier.ageed_amt}</td>
                    <td className="px-6 py-4 text-sm">{supplier.no_of_animal}</td>
                    <td className="px-6 py-4 text-sm font-medium">
                      <div className="flex space-x-3">
                        <button
                          onClick={() => handleEdit(supplier.id)}
                          className="text-blue-600 hover:text-blue-900"
                        >
                          <FaEdit size={18} />
                        </button>
                        <button
                          // onClick={() => handleDelete(supplier.id)}
                          className="text-red-600 hover:text-red-900"
                        >
                          <FaTrash size={18} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="px-6 py-10 text-center text-gray-500">
                    No suppliers found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}